import { resetReportCatalogPrime } from '../flows/primeMetricCatalog'
import { useCustomizeStore } from '../stores/customizeStore'
import { useMetricCatalogStore } from '../stores/metricCatalogStore'
import { useReportLevelStore } from '../stores/reportLevelStore'
import { useReportViewConfigStore } from '../stores/reportViewConfigStore'
import { useSavedReportFiltersStore } from '../stores/savedReportFiltersStore'
import { useVisualizationTypeCatalogStore } from '../stores/visualizationTypeCatalogStore'

import { registerSessionReset } from '@/features/auth'
import { clearCatalogCache, resetCatalogRuntime } from '@/shared/catalog'

/** Logout clears the catalog store + the §6.1 localStorage cache (BE contract: the catalog
 *  may become auth-scoped later, so stale per-token data is worse than a re-fetch) and lets
 *  the next login re-prime. Also clears the persisted per-scope view-config/saved-filter
 *  caches — a new login must not read the previous account/workspace's preferences. */
export function registerMetricCatalogSessionReset(): () => void {
  const metricStore = useMetricCatalogStore()
  const levelStore = useReportLevelStore()
  const visualizationStore = useVisualizationTypeCatalogStore()
  const customizeStore = useCustomizeStore()
  const viewConfigStore = useReportViewConfigStore()
  const savedFiltersStore = useSavedReportFiltersStore()
  return registerSessionReset(() => {
    metricStore.resetState()
    levelStore.resetState()
    visualizationStore.resetState()
    customizeStore.resetState()
    viewConfigStore.resetState()
    savedFiltersStore.resetState()
    clearCatalogCache()
    resetCatalogRuntime()
    resetReportCatalogPrime()
  })
}
